import useCheckRole from "Hooks/APICheckRole";
import { useAPI } from "Providers/APIProvider";
import React from "react";
import "semantic-ui-css/semantic.min.css";
import { Dropdown, Icon, Menu } from "semantic-ui-react";
import logo from "./callable-final-design-01.png";

type HeaderProps = {
  onSelect: Function;
};

const Header = ({ onSelect }: HeaderProps) => {
  const api = useAPI();
  const { hasRole, roles } = useCheckRole();

  const getUsername = (): string => {
    const { me } = api;
    if (me.firstName) return `${me.firstName} ${me.lastName}`;
    return me.email;
  };

  return (
    <Menu stackable>
      <Menu.Item header>
        <img id='callable-logo' src={logo} alt='callable-logo' />
      </Menu.Item>

      <Menu.Menu position='right'>
        <Dropdown item icon='block layout'>
          <Dropdown.Menu>
            <Dropdown.Header>{getUsername()}</Dropdown.Header>
            {hasRole(roles.organisation.roles.view) && (
              <Dropdown.Item onClick={() => onSelect("organisations")}>
                <Icon name='building' />
                Organisations
              </Dropdown.Item>
            )}
            {hasRole(roles.account.roles.view) && (
              <Dropdown.Item onClick={() => onSelect("accounts")}>
                <Icon name='building outline' />
                Accounts
              </Dropdown.Item>
            )}
            {hasRole(roles.ticket.roles.view) && (
              <Dropdown.Item onClick={() => onSelect("tickets")}>
                <Icon name='tag' />
                Tickets
              </Dropdown.Item>
            )}
            {hasRole(roles.billing.roles.view) && (
              <Dropdown.Item onClick={() => onSelect("billing")}>
                <Icon name='balance' />
                Billing
              </Dropdown.Item>
            )}
            {hasRole(roles.security.roles.view) && (
              <Dropdown.Item onClick={() => onSelect("security")}>
                <Icon name='shield' />
                Security
              </Dropdown.Item>
            )}
            {hasRole(roles.config.roles.view) && (
              <Dropdown.Item onClick={() => onSelect("config")}>
                <Icon name='cog' />
                Configuration
              </Dropdown.Item>
            )}
            {hasRole(roles.globalNumber.roles.view) && (
              <Dropdown.Item onClick={() => onSelect("globalNumber")}>
                <Icon name='numbered list' />
                Numbers
              </Dropdown.Item>
            )}
            <Dropdown.Divider />
            <Dropdown.Item onClick={() => api.keycloak.logout()}>
              <Icon name='sign-out' />
              Logout
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Menu.Menu>
    </Menu>
  );
};

export default Header;
